var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      staticClass: "pb-5",
    },
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("v-autocomplete", {
                  attrs: {
                    label: "Selecciona una tienda",
                    items: _vm.branchList,
                    "item-value": "branch_id",
                    "item-text": "name",
                    "menu-props": {
                      overflowY: true,
                      transition: "slide-y-transition",
                      maxWidth: "300px",
                    },
                    height: "40",
                    "single-line": "",
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    "no-data-text": "No hay tiendas",
                    "append-icon": "mdi-chevron-down",
                  },
                  model: {
                    value: _vm.selected.branch,
                    callback: function ($$v) {
                      _vm.$set(_vm.selected, "branch", $$v)
                    },
                    expression: "selected.branch",
                  },
                }),
                _c("v-spacer"),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-click": "",
                      "close-on-content-click": "",
                      "offset-y": "",
                      left: "",
                      "nudge-bottom": 10,
                      transition: "slide-y-transition",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-2",
                                    attrs: { color: "grey-900", height: 40 },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-calendar-blank "),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.filter[_vm.selected.q] ?? "Fecha")
                                ),
                                _c(
                                  "v-icon",
                                  { attrs: { size: "18", right: "" } },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Hoy")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Ayer")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Esta semana")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Semana pasada")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Este mes")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Mes pasado")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.loading
        ? [
            _c(
              "v-col",
              { staticClass: "pa-0", attrs: { cols: "12" } },
              [
                _c(
                  "v-row",
                  { staticClass: "mt-5 px-1" },
                  _vm._l(3, function (item) {
                    return _c(
                      "v-col",
                      { key: item, staticClass: "pa-0", attrs: { cols: "4" } },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "mt-n3 pa-2",
                          staticStyle: { "border-radius": "10px !important" },
                          attrs: {
                            transition: "fade-transition",
                            type: "list-item-two-line",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "v-col",
              { staticClass: "mt-10 pa-0", attrs: { cols: "12" } },
              [
                _c(
                  "v-row",
                  { staticClass: "px-1" },
                  _vm._l(2, function (item) {
                    return _c(
                      "v-col",
                      { key: item, staticClass: "pa-0", attrs: { cols: "6" } },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "mt-n3 pa-2",
                          staticStyle: { "border-radius": "10px !important" },
                          attrs: {
                            transition: "fade-transition",
                            type: "image",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : [
            !_vm.hasData
              ? _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("empty-state", {
                      staticClass: "mt-10",
                      attrs: {
                        type: "metrics-branch",
                        id: "metrics",
                        height: 320,
                        title: "¿Quieres ver el monitor?",
                        description: "Filtra para obtener registros",
                        hiddenDescription: true,
                        isFree: true,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "v-col",
                  { staticClass: "pa-0" },
                  [
                    _c(
                      "v-row",
                      { staticClass: "px-1 mt-4" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "py-0 px-2", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-md",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-subtitle-2 grey-700--text font-weight-bold",
                                  },
                                  [_vm._v("Total de ventas")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$fmt.currency(
                                            _vm.accountCurrency,
                                            _vm.summary.total_sales
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "py-0 px-2", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-md",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-subtitle-2 grey-700--text font-weight-bold",
                                  },
                                  [_vm._v("Q Tickets")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$fmt.integer(
                                            _vm.summary.total_tickets
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "py-0 px-2", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-md",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-subtitle-2 grey-700--text font-weight-bold",
                                  },
                                  [_vm._v("Ticket promedio")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$fmt.currency(
                                            _vm.accountCurrency,
                                            _vm.summary.average_ticket
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "mt-8 px-1" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "py-0 px-2", attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "d-flex flex-column",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "v-card-title",
                                  { staticClass: "pt-3 px-0" },
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color: "transparent",
                                          flat: "",
                                          height: "46",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                          },
                                          [_vm._v("Ventas")]
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex pr-5" },
                                          [
                                            _c("v-sheet", {
                                              staticClass:
                                                "d-flex mr-4 ml-1 rounded-sm",
                                              attrs: {
                                                width: "7",
                                                height: "14",
                                                color: "grey-900",
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 grey-500--text ml-n2",
                                              },
                                              [_vm._v(" Total de ventas")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card-text",
                                  { staticClass: "pb-4 flex-grow-1" },
                                  [
                                    _c("chart-line", {
                                      key: `line-${_vm.chartHeight}`,
                                      attrs: {
                                        "chart-data": _vm.salesChart,
                                        "show-legend": false,
                                        "month-label": _vm.salesMonth,
                                        "show-point": false,
                                        numberRounded:
                                          this.$store.state.auth.account
                                            .currency !== "CLP",
                                        currency: _vm.accountCurrency,
                                        height: _vm.chartHeight,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "py-0 px-2", attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "d-flex flex-column",
                                attrs: { flat: "" },
                              },
                              [
                                _c(
                                  "v-card-title",
                                  { staticClass: "pt-3 px-0" },
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color: "transparent",
                                          flat: "",
                                          height: "46",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          {
                                            staticClass:
                                              "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                          },
                                          [_vm._v("Q-Promedio por ticket")]
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex pr-5" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c("v-sheet", {
                                                  staticClass:
                                                    "d-flex mr-4 ml-1 rounded-sm",
                                                  attrs: {
                                                    width: "7",
                                                    height: "14",
                                                    color: "grey-900",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 grey-500--text ml-n2",
                                                  },
                                                  [_vm._v("Q de ticket")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "d-flex ml-5" },
                                              [
                                                _c("v-sheet", {
                                                  staticClass:
                                                    "d-flex mr-4 ml-1 rounded-sm",
                                                  attrs: {
                                                    width: "7",
                                                    height: "14",
                                                    color: "grey-900",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 grey-500--text ml-n2",
                                                  },
                                                  [_vm._v("Promedio de ventas")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card-text",
                                  { staticClass: "pb-4 flex-grow-1" },
                                  [
                                    _c("chart-bar-line", {
                                      key: `bar-line-${_vm.chartHeight}`,
                                      attrs: {
                                        "chart-data": _vm.avgTicketChart,
                                        "x-axis-label": _vm.salesMonth,
                                        "show-legend": false,
                                        "x-axis-type": "date",
                                        currency: _vm.accountCurrency,
                                        height: _vm.chartHeight,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      {
                        staticClass: "mt-8 d-flex flex-column",
                        attrs: { flat: "" },
                      },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "pt-3 px-0" },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                  },
                                  [_vm._v("Q-Promedio por caja")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-card-text", { staticClass: "pa-4 flex-grow-1" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center fill-height" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "pr-0",
                                  staticStyle: { "min-width": "180px" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-end" },
                                    [
                                      _c("v-sheet", {
                                        staticClass:
                                          "d-flex mr-4 ml-1 rounded-sm",
                                        attrs: {
                                          width: "7",
                                          height: "14",
                                          color: "grey-900",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 grey-500--text ml-n2",
                                          staticStyle: {
                                            position: "relative",
                                            top: "3px",
                                          },
                                        },
                                        [_vm._v("Q de ticket")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-end mt-3" },
                                    [
                                      _c("v-sheet", {
                                        staticClass:
                                          "d-flex mr-4 ml-1 rounded-sm",
                                        attrs: {
                                          width: "7",
                                          height: "14",
                                          color: "grey-900",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 grey-500--text ml-n2",
                                          staticStyle: {
                                            position: "relative",
                                            top: "3px",
                                          },
                                        },
                                        [_vm._v("Promedio de ventas")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "flex-grow-1",
                                  staticStyle: { width: "calc(100% - 180px)" },
                                },
                                [
                                  _c("chart-bar-line", {
                                    key: `bar-cash-${_vm.chartHeight}`,
                                    attrs: {
                                      "chart-data": _vm.avgCashChart,
                                      "x-axis-label": "Cajas",
                                      "show-legend": false,
                                      "x-axis-type": "category",
                                      currency: _vm.accountCurrency,
                                      height: _vm.chartHeight,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }